// extracted by mini-css-extract-plugin
module.exports = {"Pie":"Pie_Pie__3_6XJ","Num":"Pie_Num__2e6Lh"};